let intersectionObserver;

let initialized = false;

const effects = {
	".fx-play, *[class^='fx-'], *[class*=' fx-']": {
		"init": ( element ) => {
			element.classList.remove( 'fx-play' );
		},
		"play": ( element ) => {
			element.classList.add( 'fx-play' );
		},
		"hide": ( element ) => {
			if ( element.classList.contains( 'fx-replay' ) ) {
				element.classList.remove( 'fx-play' );
			}
		}
	},
	".animation-running, .animation-paused": {
		"play": ( element ) => {
			element.classList.replace("animation-paused", "animation-running" );
		},
		"pause": ( element ) => {
			element.classList.replace("animation-running", "animation-paused" );
		}
	},
	"video": {
		"play": ( element ) => {
			element.play();
		},
		"pause": ( element ) => {
			element.pause();
		}
	}
};

const selectors = Object.keys( effects );

/**
 * Start observing.
 *
 * @return void
 */
const observe = () => {
	intersectionObserver.disconnect();

	selectors.map( ( selector ) => {
		document.querySelectorAll( selector ).forEach(( element ) => {
			if ( ! initialized && effects[ selector ].hasOwnProperty( 'init' ) ) {
				effects[ selector ].init( element );
			}

			intersectionObserver.observe( element );
		} );
	} );

	initialized = true;
}

/**
 * Pause animations.
 *
 * @return void
 */
const pause = () => {
	intersectionObserver.disconnect();

	selectors.map( ( selector ) => {
		document.querySelectorAll( selector ).forEach( ( element ) => {
			let effect = effects[ selector ];

			if ( effect.hasOwnProperty( 'pause' ) ) {
				effect.pause( element );
			}
		} );
	} );
}

if ( ! window.matchMedia( "(prefers-reduced-motion: reduce)" )?.matches ) {
	/**
	 * Intersection observer to pause element when not in viewport.
	 */
	intersectionObserver = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				let element = entry.target;

				selectors.map( ( selector ) => {
					if ( ! element.matches( selector ) ) {
						return;
					}

					let effect = effects[ selector ];

					if ( ! entry.isIntersecting ) {
						if ( effect.hasOwnProperty( 'hide' ) ) {
							effect.hide( element );

							return;
						}

						if ( effect.hasOwnProperty( 'pause' ) ) {
							effect.pause( element );
						}

						return;
					}

					effect.play( element );
				} );
			} );
		}
	);

	/**
	 * Event listeners.
	 */
	document.addEventListener('DOMContentLoaded', observe );
	window.addEventListener('focus', observe );
	window.addEventListener('blur', pause );

	window.addEventListener( 'blur', function() {
		window.addEventListener( 'scroll', observe, { once: true } );
	} );
}
